import { OutlineXCircleIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { ConfirmPopup } from '~/commonComponents';
import AnimatedCheckCircle from '~/components/shared/AnimatedCheckCircle';

interface IReferralLinkModalsProps {
  showPopup: {
    isOpen: boolean;
    title: string;
    description: string;
    isSuccess: boolean;
    showIcon: boolean;
  };
  onClosePopup: () => void;
}

export const ReferralLinkModals = ({ showPopup, onClosePopup }: IReferralLinkModalsProps) => {
  return (
    <>
      {showPopup.isOpen && (
        <ConfirmPopup
          Icon={() =>
            showPopup.showIcon ? (
              <div style={{ marginBottom: 20 }}>
                {showPopup.isSuccess ? (
                  <AnimatedCheckCircle />
                ) : (
                  <OutlineXCircleIcon size={80} color={colors.primary[500]} />
                )}
              </div>
            ) : null
          }
          title={showPopup.title}
          description={showPopup.description}
          rightButtonAction={onClosePopup}
          rightButtonText={showPopup.isSuccess ? 'Got it!' : 'Close'}
          descriptionStyle={{ marginBottom: 40 }}
        />
      )}
    </>
  );
};
